module.exports = __webpack_public_path__ + "static/media/Rec-3-02.31251f60.webp";